module.exports = __webpack_public_path__ + "static/media/nalgov.3a17a826.png";